import { apiBeAuth } from "@/entities/auth";

export const PostFavorite = async (data: PostFavoriteReq) => {
  const responseBody = await apiBeAuth<PostFavoriteRes>("/user/watchlist", {
    method: "POST",
    body: JSON.stringify(data),
  });

  return responseBody;
};
